/** Removes all whitespace from a string — for inputs where whitespace is never valid (e.g. email). */
export const removeWhitespace = (value: string): string => value.replace(/\s+/g, '');

export const pluralize = (word: string, count: number, pluralOverride?: string): string => {
  if (count === 1) return word;
  if (pluralOverride) return pluralOverride;

  // Words ending in s, x, z, ch, sh → add "es"
  if (/(?:s|x|z|ch|sh)$/i.test(word)) return `${word}es`;

  return `${word}s`;
};

export function capitalizeEveryFirstLetter(str: string) {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
}

// Format number with commas for display
export const formatNumberInput = (
  value: string,
  allowDecimals: boolean,
  maxDecimals: number,
): string => {
  // Remove all non-numeric characters except decimal point
  let cleaned = value.replace(/[^\d.]/g, '');

  if (!allowDecimals) {
    // Remove decimal point if decimals not allowed
    cleaned = cleaned.replace(/\./g, '');
  } else {
    // Ensure only one decimal point
    const parts = cleaned.split('.');
    if (parts.length > 2) {
      cleaned = parts[0] + '.' + parts.slice(1).join('');
    }

    // Limit decimal places
    if (parts.length === 2 && parts[1].length > maxDecimals) {
      cleaned = parts[0] + '.' + parts[1].substring(0, maxDecimals);
    }
  }

  return cleaned;
};

/** The longest first or last name the portal accepts (sign-up and My profile). */
export const PERSON_NAME_MAX_LENGTH = 50;

/** Letters in any script, spaces, hyphens, apostrophes and periods (sign-up and My profile). */
export const PERSON_NAME_PATTERN = /^[\p{L} '\-.]+$/u;

/**
 * React Hook Form rules for a first or last name, as sign-up and My profile
 * check it. `label` names the field in the required message, e.g. "First name".
 */
export const getPersonNameRules = (label: string) => ({
  required: `${label} is required`,
  maxLength: {
    value: PERSON_NAME_MAX_LENGTH,
    message: `Maximum ${PERSON_NAME_MAX_LENGTH} characters`,
  },
  pattern: {
    value: PERSON_NAME_PATTERN,
    message: 'Use letters, spaces, hyphens, apostrophes, or periods only',
  },
});
